import * as React from "react"
import { Row } from "react-grid-system"
import { useTranslation } from "react-i18next"
import { SlideOutHeight } from "../atoms/animations/SlideOutHeight"
import SharedDataChartView from "./charts/SharedDataChartView"
import DataPlanChartsView from "./charts/SingleDataPlanChartsView"
import { HorizontalSpacer } from "../atoms/spacers"
import { DataPlanModel } from "../../utils/models"
import Card from "../atoms/Card"
import TextButton from "../atoms/buttons/TextButton"
import AddDataSection from "../molecules/AddDataSection"
import DataPlanOverviewBar from "../molecules/DataPlans/DataPlanOverviewBar"
import DataPlanTerminalsOverview from "../molecules/DataPlans/DataPlanTerminalsOverview"
import { ArrowDropUpIcon } from "../atoms/icons/ArrowDropUpIcon"
import { ArrowDropDownIcon } from "../atoms/icons/ArrowDropDownIcon"

interface Props {
  dataplan: DataPlanModel
  cardOpen: boolean
  onClickCard: (id: string) => void
}

const DataPlanOverviewCard: React.FunctionComponent<Props> = ({ dataplan, cardOpen, onClickCard }) => {
  const { t } = useTranslation()
  const [showTerminals, setShowTerminals] = React.useState(false)
  const [addDataOpen, setAddDataOpen] = React.useState(false)

  return (
    <div>
      <Card noPadding>
        <DataPlanOverviewBar
          dataplan={dataplan}
          onClickAddData={() => setAddDataOpen(!addDataOpen)}
          onClickStatistics={() => onClickCard(dataplan.id)}
          statisticsOpen={cardOpen}
        />
        <HorizontalSpacer spacing={1} />
        <SlideOutHeight isVisible={cardOpen}>
          {dataplan.sharedPlan ? (
            <SharedDataChartView
              dataplan={dataplan}
              name={dataplan.actionBarProps.dataPlanName}
              id={parseInt(dataplan.id)}
            />
          ) : (
            <DataPlanChartsView
              dataplan={dataplan}
              name={dataplan.actionBarProps.dataPlanName}
              dataLastSynced={dataplan.dataLastSynced}
              singlePlanApiId={dataplan.apiPlanId}
            />
          )}
        </SlideOutHeight>
        <AddDataSection
          apiPlanId={dataplan.apiPlanId}
          onClickCancel={() => setAddDataOpen(false)}
          dataPlanName={dataplan.name}
          isOpen={addDataOpen}
        />
        <Row justify="center">
          <TextButton
            title={t("terminals")}
            icon={showTerminals ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            onClick={() => setShowTerminals(!showTerminals)}
          />
        </Row>
        <HorizontalSpacer spacing={1} />
        <SlideOutHeight isVisible={showTerminals}>
          <DataPlanTerminalsOverview
            terminals={dataplan.terminalData}
            sharedPlan={dataplan.sharedPlan}
            apiPlanId={dataplan.apiPlanId}
          />
        </SlideOutHeight>
      </Card>

      <HorizontalSpacer spacing={3} />
    </div>
  )
}

export default DataPlanOverviewCard
